module.exports = __webpack_public_path__ + "img/bg2.a9927cd5.png";